// extracted by mini-css-extract-plugin
export default {"container":"src-components-Modules-revamp-ErrorSection-css-module__container--XeTDk"};